<template>
  <div class="d-flex flex-row u-track">
    <div class="d-flex flex-row list-group align-items-center justify-content-center w-100">
      <div class="mx-4 dropdown show">
        <p class="dropdown-toggle" role="button" id="dropdownMenuLink" @click="toUpload">
          <!-- <img src="../assets/music-track.png" alt="" height="20" width="20" /> -->
          Get Started
        </p>
        <!-- <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <div class="d-flex flex-row dropdown-item justify-content-between align-items-center">
            <router-link v-if="!disableStereo" :to="{ name: 'uploadtrack', params: { cat: 'stereo' } }">Full Stereo
              Mix</router-link>
            <a v-else href="https://getmxd.com/pricing/" class="mix-disable">Full Stereo Mix <span
                class="badge badge-pill badge-warning mx-2 mix-badge">Buy</span></a>
            <button type="button" class="ml-3 btn btn-secondary" data-container="body" data-toggle="popover"
              data-placement="right" data-content="Full Stereo Mix">
              ?
            </button>
          </div>

          <div class="d-flex flex-row dropdown-item justify-content-between align-items-center">
            <router-link v-if="!disableTracks" :to="{ name: 'uploadtrack', params: { cat: 'track' } }">2 Track
              Mix</router-link>
            <a v-else href="https://getmxd.com/pricing/" class="mix-disable">2 Track Mix <span
                class="badge badge-pill badge-warning mx-2 mix-badge">Buy</span></a>
            <button type="button" class="ml-3 btn btn-secondary" data-container="body" data-toggle="popover"
              data-placement="right" data-content="2 Track Mix">
              ?
            </button>
          </div>

          <div class="d-flex flex-row dropdown-item justify-content-between align-items-center">
            <router-link v-if="!disableAtmos" :to="{ name: 'uploadtrack', params: { cat: 'atmos' } }">ATMOS
              Mix</router-link>
            <a v-else href="https://getmxd.com/pricing/" class="mix-disable">ATMOS Mix <span
                class="badge badge-pill badge-warning mx-2 mix-badge">Buy</span></a>
            <button type="button" class="ml-3 btn btn-secondary" data-container="body" data-toggle="popover"
              data-placement="right" data-content="ATMOS Mix">
              ?
            </button>
          </div>
          <div class="d-flex flex-row dropdown-item justify-content-between align-items-center">
            <router-link v-if="!disableMastering"
              :to="{ name: 'mastering', params: { cat: 'mastering' } }">Mastering</router-link>
            <a v-else href="https://getmxd.com/pricing/" class="mix-disable">Mastering <span
                class="badge badge-pill badge-warning mx-2 mix-badge">Buy</span></a>
            <button type="button" class="ml-3 btn btn-secondary" data-container="body" data-toggle="popover"
              data-placement="right" data-content="ATMOS Mix">
              ?
            </button>
          </div>
        </div> -->
      </div>

      <!-- <button v-b-modal.newProjectModal class="btn-p add-p d-flex"> -->
      <!-- <img class="mx-1" src="../assets/plus.png" alt="" height="25" width="25" /> -->
      <!-- Add Project
      </button> -->
    </div>

    <div class="p-modal">
      <!-- <b-modal
        id="newTrackModal"
        centered
        title="Add New Track"
        :header-class="headerClass"
        :body-class="bodyClass"
        :footer-class="footerClass"
      >
        <NewTrackForm/>
        <template slot="modal-header">
          <div>
            <BaseIcon name="music"/>&nbsp; Add new Track
          </div>
        </template>
        <template slot="modal-footer">
          <div class="m-0 p-0 h-0"></div>
        </template>
      </b-modal> -->

      <b-modal id="newProjectModal" hide-footer centered :header-class="headerClass" :body-class="bodyClass">
        <p class="px-3 text-center modal-text">
          It is better creating a project to manage all tracks.
        </p>
        <NewProjectForm />
      </b-modal>
    </div>
  </div>
</template>

<script>
import NewProjectForm from "@/components/NewProjectForm.vue";
export default {
  components: {
    NewProjectForm,
  },
  data() {
    return {
      headerClass: "card-modal-header",
      bodyClass: "card-bg",
      footerClass: "card-modal-footer",
    };
  },
  methods: {
    toUpload() {
      this.$router.push('/uploadtrack')
    }
  },
  computed: {
    disableStereo() {
      return this.$store.state.apiEvents.remainingStereoMix > 0
        ? 0
        : 1;
    },
    disableAtmos() {
      return this.$store.state.apiEvents.remainingAtmosMix > 0
        ? 0
        : 1;
    },
    disableTracks() {
      return this.$store.state.apiEvents.remainingTracks > 0
        ? 0
        : 1;
    },
    disableMastering() {
      return this.$store.state.apiEvents.remainingMasteringMix > 0
        ? 0
        : 1;
    },
    disabledClass() {
      return this.$store.state.apiEvents.remainingTracks > 0 ||
        this.$store.state.apiEvents.remainingTracks == -1
        ? " btn-t"
        : " btn-t-disabled";
    },
    disabledButton() {
      return this.$store.state.apiEvents.remainingTracks > 0 ||
        this.$store.state.apiEvents.remainingTracks == -1
        ? 0
        : 1;
    },
  },
};
</script>

<style>
.modal-text {
  color: #1a1c22;
}

.disabled-button {
  background-color: #ff0000 !important;
}

.u-track .dropdown {
  padding: 0px 2px;
  border-radius: 100px !important;
  font-weight: 400;
  background-color: #1defd2;
  text-transform: uppercase;
  color: #ffffff;
}

.dropdown a {
  color: #ffffff;
  text-decoration: none !important;
}

.dropdown a:hover {
  color: #dadada;
}

.u-track .dropdown p {
  margin: 8px 4px;
  padding: 0 !important;
  color: #24262e !important;
}

.u-track .dropdown .dropdown-item {
  color: #ffffff !important;
}

.u-track .dropdown .dropdown-menu {
  background-color: #24262e !important;
}

.mix-disable {
  color: #9b9b9b !important;
}

.mix-badge {
  font-size: 8px !important;
}
</style>
